import axios from "axios";

// Employee master. None of these endpoints exist on the server yet — the full
// contract (request and response shapes) is docs/BACKEND-COMPLETE.md (Part 4.3).
const base_path = window.APP_CONFIG?.BASE_URL;

export const getEmployeeList = async (globalBranchID) => {
  const response = await axios.get(
    `${base_path}/api/Employee/GetAllByBranch?globalBranchID=${globalBranchID}`
  );
  return response.data;
};

export const getEmployeeByGuid = async (guid) => {
  const response = await axios.get(`${base_path}/api/Employee/GetByGuid?guid=${guid}`);
  return response.data;
};

export const getEmployeeLookups = async () => {
  const response = await axios.get(`${base_path}/api/Employee/GetLookups`);
  return response.data;
};

export const getNextEmployeeCode = async () => {
  const response = await axios.get(`${base_path}/api/Employee/GetNextCode`);
  return response.data;
};

export const addEmployee = async (data) => {
  const response = await axios.post(`${base_path}/api/Employee/Save`, data);
  return response;
};

export const editEmployee = async (data) => {
  const response = await axios.post(`${base_path}/api/Employee/Update`, data);
  return response;
};

export const deleteEmployee = async (data) => {
  const response = await axios.post(`${base_path}/api/Employee/Delete`, data);
  return response;
};

// { Guids: [], Action: "MarkLeft" | "MakeSalesman" | "TransferBranch", BranchGuid?, DateOfLeaving? }
export const bulkUpdateEmployees = async (data) => {
  const response = await axios.post(`${base_path}/api/Employee/BulkUpdate`, data);
  return response;
};

// { Guids: [], DocumentTypes?: [] } — mails / notifies HR, the PRO and each person
export const sendRenewalReminder = async (data) => {
  const response = await axios.post(`${base_path}/api/Employee/SendRenewalReminder`, data);
  return response;
};

// multipart: employeeGuid, documentGuid, documentType, file
export const uploadEmployeeDocument = async (formData) => {
  const response = await axios.post(`${base_path}/api/Employee/UploadDocument`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const deleteEmployeeDocumentFile = async (fileGuid) => {
  const response = await axios.post(
    `${base_path}/api/Employee/DeleteDocumentFile`,
    JSON.stringify(fileGuid),
    { headers: { "Content-Type": "application/json" } }
  );
  return response;
};

// creates an ERP user from the employee and links it
export const createUserFromEmployee = async (data) => {
  const response = await axios.post(`${base_path}/api/Employee/CreateUser`, data);
  return response.data;
};
